import {
  setMyLoungeActionType,
  LoungeManagementThunk,
  SET_VALID_LOUNGE_BY_ID,
  SetValidLoungeByIdActionType,
  LOUNGE_MANAGEMENT_SET_LOUNGES,
  LOUNGE_MANAGEMENT_SET_MY_LOUNGE,
  loungeManagementSetLoungesActionType,
} from './loungeManagementActionTypes';
import { CREDITS_NAMESPACE } from '../credits/creditsReducer';
import { BookLounge, LoungeResource } from './loungesManagementTypes';
import LoungeManagementApi from '../../API/lounge/LoungeManagement.api';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';

export function loungeManagementSetLoungeAction(
  lounges: LoungeResource[]
): loungeManagementSetLoungesActionType {
  return {
    type: LOUNGE_MANAGEMENT_SET_LOUNGES,
    payload: lounges,
  };
}

export function setMyLoungeAction(
  lounge: LoungeResource
): setMyLoungeActionType {
  return {
    type: LOUNGE_MANAGEMENT_SET_MY_LOUNGE,
    payload: lounge,
  };
}

export function setLoungeByIdAction(
  lounge: LoungeResource
): SetValidLoungeByIdActionType {
  return {
    type: SET_VALID_LOUNGE_BY_ID,
    payload: lounge,
  };
}

export function loungeManagementFetchLoungesThunk(): LoungeManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    LoungeManagementApi.getLounges()
      .then((response) => {
        dispatch(loungeManagementSetLoungeAction(response.data));
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}

export function loungeManagementFetchLoungeByIdThunk(
  id: number
): LoungeManagementThunk<Promise<any>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    return LoungeManagementApi.getLoungeById(id)
      .then((response) => {
        return response.data;
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function loungeManagementBookLounge(
  data: BookLounge
): LoungeManagementThunk<Promise<any>> {
  return async (dispatch, getState) => {
    const { AUTH_NAMESPACE } = getState();
    const { profile } = AUTH_NAMESPACE;
    const creditState = getState()[CREDITS_NAMESPACE];
    dispatch(startLoaderThunk()).finally();

    const allocation = {
      ...data,
      user_id: profile?.id,
      company_id: profile?.company?.id || -1,
    };

    const creditBalance = {
      credit_payments: creditState.creditInUse?.activeCredits?.map((credit) => {
        return {
          credit_balance_id: credit.id,
          credit_amount: credit.amount,
        };
      }),
      usage: creditState.creditInUse?.creditsAmount || undefined,
      credit_amount: creditState.creditInUse?.creditsAmount || undefined,
      cash_amount: creditState.creditInUse?.cashAmount || undefined,
    };
    try {
      await LoungeManagementApi.bookLoungeAllocation(allocation, creditBalance);
      return {
        isSuccessfull: true,
        errorMessage: null,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.error?.message || 'Unavailbale at this time';
      return {
        isSuccessfull: false,
        errorMessage,
      };
    } finally {
      dispatch(stopLoaderThunk()).finally();
    }
  };
}

export function FetchMyLoungeThunk(): LoungeManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    const { AUTH_NAMESPACE } = getState();
    const { profile } = AUTH_NAMESPACE;
    let id = 0;
    if (profile?.locationId) {
      id = profile?.locationId;
    }
    return LoungeManagementApi.getMyLoungeByLocationId(id)
      .then((response) => {
        dispatch(setMyLoungeAction(response.data));
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}

export function resourceManagementFetchValidLoungeByIdThunk(
  id: number
): LoungeManagementThunk<Promise<any>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    return LoungeManagementApi.getValidLoungeById(id)
      .then((response) => {
        dispatch(setLoungeByIdAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}
